export default "__VITE_ASSET__6ceff9fb__"